import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import type { ThreadsResponse } from "@/entities/thread";
import { apiGet } from "@/shared/api";
import { useCurrentBoardSlug } from "@/shared/hooks/useCurrentBoardSlug";
import { useCatalogStore } from "../stores/catalogStore";

export function useThreads(): UseQueryResult<ThreadsResponse> {
  const slug = useCurrentBoardSlug();
  const { currentSort } = useCatalogStore();

  return useQuery({
    queryKey: ["threads", slug, currentSort],
    queryFn: async () => {
      const params = new URLSearchParams({ limit: "500" });
      if (currentSort !== "default") params.set("sort", currentSort);
      return apiGet<ThreadsResponse>(`/threads/${slug}?${params.toString()}`);
    },
    staleTime: 30_000,
    retry: 1,
    refetchOnWindowFocus: true,
  });
}
